import { j as o } from "../../../jsx-runtime-82a9ddf6.js";
const C = ({ width: r = 20, height: t = 20, className: e, style: n }) => /* @__PURE__ */ o.jsxs(
  "svg",
  {
    width: r,
    height: t,
    className: e,
    style: n,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ o.jsx("path", { d: "M10 7.5V9.16667M10 12.5V12.5083", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ o.jsx("path", { d: "M4.16666 15.8333H15.8333C16.1053 15.8314 16.3726 15.763 16.612 15.6341C16.8514 15.5051 17.0556 15.3195 17.2068 15.0935C17.3581 14.8675 17.4517 14.608 17.4795 14.3375C17.5074 14.067 17.4686 13.7937 17.3667 13.5417L11.45 3.33333C11.3059 3.07283 11.0946 2.85569 10.8381 2.70449C10.5817 2.55328 10.2894 2.47354 9.99166 2.47354C9.69395 2.47354 9.40166 2.55328 9.1452 2.70449C8.88874 2.85569 8.67746 3.07283 8.53333 3.33333L2.61666 13.5417C2.51661 13.788 2.47694 14.0547 2.50095 14.3194C2.52497 14.5842 2.61197 14.8394 2.75471 15.0637C2.89744 15.288 3.09175 15.4749 3.32143 15.6087C3.55111 15.7426 3.80949 15.8196 4.075 15.8333", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
    ]
  }
);
export {
  C as AlertIcon
};
